function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import SlideTitle from "../slide-title/SlideTitle";
import SlideImage from "../slide-image/SlideImage";
import SlideBody from "../slide-body/SlideBody";
import SlideCloseIcon from "../slide-close-icon/SlideCloseIcon";
const TextImageSlideBody = ({
  classes,
  slide,
  shouldAnimate,
  ...rest
}) => {
  const {
    imgSrc,
    headline,
    primaryColour,
    contrastColour,
    headlineColor,
    roundImage
  } = slide;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContainer,
    style: {
      backgroundColor: primaryColour
    }
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: true,
    style: {
      color: contrastColour,
      backgroundColor: primaryColour
    }
  }), /*#__PURE__*/React.createElement(SlideImage, {
    imgSrc: imgSrc,
    primaryColour: primaryColour,
    shouldAnimate: shouldAnimate,
    roundImage: roundImage
  }), /*#__PURE__*/React.createElement(SlideCloseIcon, _extends({
    slide: slide
  }, rest))), /*#__PURE__*/React.createElement("div", {
    className: classes.headlineContainer
  }, /*#__PURE__*/React.createElement(SlideBody, {
    headline: headline,
    shouldAnimate: shouldAnimate,
    color: headlineColor
  })));
};
const styles = {
  headerContainer: {
    height: "60%",
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "hidden"
  },
  "@media screen and (min-width: 450px)": {
    headerContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      maxHeight: 320
    }
  },
  headlineContainer: {
    display: "flex",
    flexBasis: "25%"
  }
};
export default withStyles(styles)(TextImageSlideBody);
TextImageSlideBody.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool,
  slide: PropTypes.object.isRequired
};